import { Enum, EnumType } from 'ts-jenum';
import _ from 'lodash';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faArrowRight, faUser, faRandom, faTimes, faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

@Enum<ConversationStatus>('value')
export class ConversationStatus extends EnumType<ConversationStatus>() {
   static readonly UNKNOWN = new ConversationStatus('Unknown', 0);
   static readonly NO_ANSWER = new ConversationStatus('NoAnswer', 1, faArrowLeft, 'status-no-answer', 'shrink-5 left-6 up-5 rotate-40');
   static readonly MISSED = new ConversationStatus('Missed', 2, faArrowRight, 'status-missed', 'shrink-5 left-6 up-5 rotate-40');
   static readonly INBOUND_ANSWERED = new ConversationStatus('InboundAnswered', 3, faArrowRight, 'status-inbound-answered', 'shrink-5 left-6 up-5 rotate-40');
   static readonly OUTBOUND_ANSWERED = new ConversationStatus('OutboundAnswered', 4, faArrowLeft, 'status-outbound-answered', 'shrink-5 left-6 up-5 rotate-45');
   static readonly TRANSFERRED = new ConversationStatus('Transferred', 5, faRandom, 'status-transferred', 'shrink-6 left-6 up-5');
   static readonly PENDING_TRANSFER = new ConversationStatus('PendingTransfer', 6, faRandom, 'status-pending-transfer', 'shrink-6 left-6 up-5');
   static readonly DECLINED = new ConversationStatus('Declined', 7, faTimes, 'status-declined', 'shrink-5 left-6 up-5');
   static readonly CONSULTATION = new ConversationStatus('Consultation', 8, faUser, 'status-consulation', 'shrink-6 left-6 up-5');

   private constructor(
      public value: string,
      public samwinValue: number,
      public icon: IconDefinition = null,
      public styleClass: string = null,
      public iconTransformCommand: string = null
   ) {
      super();
   }

   public static valueBySamwinValue(samwinValue: number): ConversationStatus {
      const result = _(ConversationStatus.values()).find((x) => x.samwinValue === samwinValue);
      return _.isNil(result) ? ConversationStatus.UNKNOWN : result;
   }
}
